// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Footer Premium — Ofertiz
   Design: Dark background, 4-column grid, micro-animations
   ============================================================ */

/* ---- Root -------------------------------------------------- */
.footer-root {
  background: #f4f6fb;
  color: #555570;
  margin-top: 60px;
  position: relative;
  overflow: hidden;
  border-top: 1px solid #e0e4ef;
}

/* ---- Top bar decorativa ------------------------------------ */
.footer-top-bar {
  height: 3px;
  background: linear-gradient(90deg, transparent 0%, #3483fa 35%, #2d6eea 65%, transparent 100%);
}

/* ---- Grid principal --------------------------------------- */
.footer-grid {
  display: grid;
  grid-template-columns: 1.8fr 1fr 1fr 1fr;
  gap: 48px;
  padding: 56px 0 40px;
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }
}

@media (max-width: 600px) {
  .footer-grid {
    grid-template-columns: 1fr;
    gap: 32px;
    padding: 40px 0 28px;
  }
}

/* ---- Coluna Brand ----------------------------------------- */
.footer-brand-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-logo-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #3483fa;
  color: #fff;
  font-size: 18px;
  font-weight: 900;
  border-radius: 8px;
  flex-shrink: 0;
}

.footer-logo-text {
  font-size: 22px;
  font-weight: 800;
  color: #0f0f1a;
  letter-spacing: -0.5px;
}

.footer-tagline {
  font-size: 13.5px;
  line-height: 1.65;
  color: #6e6e85;
  max-width: 280px;
  margin: 0;
}

/* ---- Social Buttons --------------------------------------- */
.footer-socials {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.footer-social-btn {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid #d8deec;
  background: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #8888aa;
  transition: background 0.22s, color 0.22s, transform 0.22s, border-color 0.22s;
}

.footer-social-btn:hover {
  background: #eef2ff;
  color: var(--social-color, #3483fa);
  border-color: #c0cafe;
  transform: translateY(-3px);
}

.footer-social-btn--done {
  background: #e8faf2;
  border-color: #a3e6c8;
  color: #1da462;
}

.footer-social-check {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 16px;
  height: 16px;
  background: #1da462;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: #fff;
  border: 1.5px solid #f4f6fb;
}

/* ---- Coins hint ------------------------------------------ */
.footer-coins-hint {
  margin: 0;
  font-size: 12px;
  color: #888899;
  display: flex;
  align-items: center;
  gap: 6px;
}

.footer-coins-hint i {
  color: #f5a623;
}

.footer-coins-hint strong {
  color: #f5a623;
}

/* ---- Colunas de links ------------------------------------- */
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-col-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: #1a1a33;
  margin: 0;
}

.footer-col-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3483fa;
  flex-shrink: 0;
}

.footer-link-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.footer-link {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 13.5px;
  color: #555570;
  text-decoration: none;
  transition: color 0.18s, gap 0.18s;
}

.footer-link:hover {
  color: #1a1a33;
  gap: 12px;
}

.footer-link-icon {
  font-size: 11px;
  color: #3483fa;
  flex-shrink: 0;
  width: 14px;
  text-align: center;
  transition: transform 0.18s;
}

.footer-link:hover .footer-link-icon {
  transform: scale(1.2);
}

.footer-link--whatsapp:hover {
  color: #25D366;
}

.footer-link--whatsapp:hover .footer-link-icon {
  color: #25D366;
}

/* ---- Badge LGPD ------------------------------------------ */
.footer-lgpd-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  background: #eef3ff;
  border: 1px solid #c5d5f8;
  border-radius: 6px;
  font-size: 11.5px;
  color: #3468cc;
  margin-top: 8px;
  width: fit-content;
}

.footer-lgpd-badge i {
  font-size: 12px;
}

/* ---- Bottom bar ------------------------------------------ */
.footer-bottom {
  border-top: 1px solid #d8deec;
  padding: 20px 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.footer-copyright {
  font-size: 12px;
  color: #9999b0;
}

.footer-devaspect {
  font-size: 13px;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  text-decoration: none;
  color: #888899;
  letter-spacing: -0.3px;
  transition: color 0.2s;
}

.footer-devaspect:hover {
  color: #444455;
}

.footer-devaspect-accent {
  color: #6A0DAD;
}

/* ---- Reduced motion --------------------------------------- */
@media (prefers-reduced-motion: reduce) {
  .footer-social-btn,
  .footer-link,
  .footer-link-icon {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE,iEAAiE;AACjE;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,8FAA8F;AAChG;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* ============================================================\n   Footer Premium — Ofertiz\n   Design: Dark background, 4-column grid, micro-animations\n   ============================================================ */\n\n/* ---- Root -------------------------------------------------- */\n.footer-root {\n  background: #f4f6fb;\n  color: #555570;\n  margin-top: 60px;\n  position: relative;\n  overflow: hidden;\n  border-top: 1px solid #e0e4ef;\n}\n\n/* ---- Top bar decorativa ------------------------------------ */\n.footer-top-bar {\n  height: 3px;\n  background: linear-gradient(90deg, transparent 0%, #3483fa 35%, #2d6eea 65%, transparent 100%);\n}\n\n/* ---- Grid principal --------------------------------------- */\n.footer-grid {\n  display: grid;\n  grid-template-columns: 1.8fr 1fr 1fr 1fr;\n  gap: 48px;\n  padding: 56px 0 40px;\n}\n\n@media (max-width: 1024px) {\n  .footer-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 36px;\n  }\n}\n\n@media (max-width: 600px) {\n  .footer-grid {\n    grid-template-columns: 1fr;\n    gap: 32px;\n    padding: 40px 0 28px;\n  }\n}\n\n/* ---- Coluna Brand ----------------------------------------- */\n.footer-brand-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.footer-logo-tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  background: #3483fa;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 900;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.footer-logo-text {\n  font-size: 22px;\n  font-weight: 800;\n  color: #0f0f1a;\n  letter-spacing: -0.5px;\n}\n\n.footer-tagline {\n  font-size: 13.5px;\n  line-height: 1.65;\n  color: #6e6e85;\n  max-width: 280px;\n  margin: 0;\n}\n\n/* ---- Social Buttons --------------------------------------- */\n.footer-socials {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.footer-social-btn {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  border: 1px solid #d8deec;\n  background: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #8888aa;\n  transition: background 0.22s, color 0.22s, transform 0.22s, border-color 0.22s;\n}\n\n.footer-social-btn:hover {\n  background: #eef2ff;\n  color: var(--social-color, #3483fa);\n  border-color: #c0cafe;\n  transform: translateY(-3px);\n}\n\n.footer-social-btn--done {\n  background: #e8faf2;\n  border-color: #a3e6c8;\n  color: #1da462;\n}\n\n.footer-social-check {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  width: 16px;\n  height: 16px;\n  background: #1da462;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 8px;\n  color: #fff;\n  border: 1.5px solid #f4f6fb;\n}\n\n/* ---- Coins hint ------------------------------------------ */\n.footer-coins-hint {\n  margin: 0;\n  font-size: 12px;\n  color: #888899;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.footer-coins-hint i {\n  color: #f5a623;\n}\n\n.footer-coins-hint strong {\n  color: #f5a623;\n}\n\n/* ---- Colunas de links ------------------------------------- */\n.footer-col {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footer-col-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.2px;\n  color: #1a1a33;\n  margin: 0;\n}\n\n.footer-col-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #3483fa;\n  flex-shrink: 0;\n}\n\n.footer-link-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.footer-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  font-size: 13.5px;\n  color: #555570;\n  text-decoration: none;\n  transition: color 0.18s, gap 0.18s;\n}\n\n.footer-link:hover {\n  color: #1a1a33;\n  gap: 12px;\n}\n\n.footer-link-icon {\n  font-size: 11px;\n  color: #3483fa;\n  flex-shrink: 0;\n  width: 14px;\n  text-align: center;\n  transition: transform 0.18s;\n}\n\n.footer-link:hover .footer-link-icon {\n  transform: scale(1.2);\n}\n\n.footer-link--whatsapp:hover {\n  color: #25D366;\n}\n\n.footer-link--whatsapp:hover .footer-link-icon {\n  color: #25D366;\n}\n\n/* ---- Badge LGPD ------------------------------------------ */\n.footer-lgpd-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  background: #eef3ff;\n  border: 1px solid #c5d5f8;\n  border-radius: 6px;\n  font-size: 11.5px;\n  color: #3468cc;\n  margin-top: 8px;\n  width: fit-content;\n}\n\n.footer-lgpd-badge i {\n  font-size: 12px;\n}\n\n/* ---- Bottom bar ------------------------------------------ */\n.footer-bottom {\n  border-top: 1px solid #d8deec;\n  padding: 20px 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.footer-copyright {\n  font-size: 12px;\n  color: #9999b0;\n}\n\n.footer-devaspect {\n  font-size: 13px;\n  font-weight: 700;\n  font-family: 'Montserrat', sans-serif;\n  text-decoration: none;\n  color: #888899;\n  letter-spacing: -0.3px;\n  transition: color 0.2s;\n}\n\n.footer-devaspect:hover {\n  color: #444455;\n}\n\n.footer-devaspect-accent {\n  color: #6A0DAD;\n}\n\n/* ---- Reduced motion --------------------------------------- */\n@media (prefers-reduced-motion: reduce) {\n  .footer-social-btn,\n  .footer-link,\n  .footer-link-icon {\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
